/* eslint-disable react/self-closing-comp */
/* eslint-disable react/prop-types */
import React from 'react';
// import React, { useState, useEffect } from 'react';
// import { Storage } from 'aws-amplify';
// import { ExternalLink } from 'react-external-link';
import { Icon, Grid, Segment, Message, Form, Label, Progress } from 'semantic-ui-react';

const ComplaintView = ({ complaint }) => {
  // const [urlS3, setUrlS3] = useState('');

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (complaint.filename !== '') {
  //       const result = await Storage.get(complaint.filename, {
  //         level: 'public'
  //       });
  //       console.log(result);
  //       setUrlS3(result);
  //     }
  //   };

  //   fetchData();
  // }, [complaint.filename]);

  return (
    <>
      {complaint && (
        <>
          <Form size="large" className="attached fluid segment">
            <Segment.Group>
              <Segment color="blue">
                <Label as="a" color="blue" ribbon>
                  Statut de la plainte
                </Label>
                <Message info>
                  <Message.Header> {complaint.statut}</Message.Header>
                  <Progress percent={55} color="blue"></Progress>
                </Message>
              </Segment>
              <Segment color="blue">
                <Label as="a" color="blue" ribbon>
                  Description de la plainte
                </Label>
                <Message color='teal'>
                  <Message.Header as='h4'>Réference de confirmation</Message.Header>
                  L'enregistrement de votre plainte a réussi. Utiliser votre réference de
                  confirmation ci-dessous pour retrouver votre plainte: {complaint.confirmation}
                </Message>

                <Segment.Group>
                  <Segment attached>
                    <Grid verticalAlign="middle">
                      <Grid.Column width={1}>
                        <Icon name="calendar" size="large" color="blue" />
                      </Grid.Column>
                      <Grid.Column width={15}>{complaint.createdAt}</Grid.Column>
                    </Grid>
                  </Segment>
                  <Segment attached>
                    <Grid verticalAlign="middle">
                      <Grid.Column width={1}>
                        <Icon name="address book" size="large" color="blue" />
                      </Grid.Column>
                      <Grid.Column width={15}>{complaint.firstname}</Grid.Column>
                    </Grid>
                  </Segment>
                  <Segment attached>
                    <Grid verticalAlign="middle">
                      <Grid.Column width={1}>
                        <Icon name="address book outline" size="large" color="blue" />
                      </Grid.Column>
                      <Grid.Column width={15}>{complaint.lastname}</Grid.Column>
                    </Grid>
                  </Segment>
                  <Segment attached>
                    <Grid verticalAlign="middle">
                      <Grid.Column width={1}>
                        <Icon name="at" size="large" color="blue" />
                      </Grid.Column>
                      <Grid.Column width={15}>{complaint.email}</Grid.Column>
                    </Grid>
                  </Segment>
                  <Segment attached>
                    <Grid verticalAlign="middle">
                      <Grid.Column width={1}>
                        <Icon name="phone" size="large" color="blue" />
                      </Grid.Column>
                      <Grid.Column width={15}>{complaint.phone}</Grid.Column>
                    </Grid>
                  </Segment>
                  <Segment attached>
                    <Grid verticalAlign="middle">
                      <Grid.Column width={1}>
                        <Icon name="warehouse" size="large" color="blue" />
                      </Grid.Column>
                      <Grid.Column width={15}>{complaint.company}</Grid.Column>
                    </Grid>
                  </Segment>
                  <Segment attached>
                    <Grid verticalAlign="middle">
                      <Grid.Column width={1}>
                        <Icon name="file text" size="large" color="blue" />
                      </Grid.Column>
                      <Grid.Column width={15}>{complaint.complaintType}</Grid.Column>
                    </Grid>
                  </Segment>
                  <Segment attached>
                    <Grid>
                      <Grid.Column width={1}>
                        <Icon size="large" color="blue" name="info circle" />
                      </Grid.Column>
                      <Grid.Column width={15}>
                        <p>{complaint.object}</p>
                      </Grid.Column>
                    </Grid>
                  </Segment>

                  <Segment attached>
                    <Grid>
                      <Grid.Column width={1}>
                        <Icon size="large" color="blue" name="info" />
                      </Grid.Column>
                      <Grid.Column width={15}>
                        <p>{complaint.description}</p>
                      </Grid.Column>
                    </Grid>
                  </Segment>
                  {/* <Segment attached>
                    <Grid>
                      <Grid.Column width={1}>
                        <Icon size="large" color="blue" name="download" />
                      </Grid.Column>
                      <Grid.Column width={15}>
                        <ExternalLink href={urlS3}>
                          <span> {complaint.filename}</span>
                        </ExternalLink>
                      </Grid.Column>
                    </Grid>
                  </Segment> */}
                  <Segment attached>
                    <Grid>
                      <Grid.Column width={1}>
                        <Icon size="large" color="blue" name="cloud upload" />
                      </Grid.Column>
                      <Grid.Column width={15}>
                        <p>{complaint.modeSoumission}</p>
                      </Grid.Column>
                    </Grid>
                  </Segment>
                </Segment.Group>
              </Segment>
            </Segment.Group>
          </Form>
        </>
      )}
    </>
  );
};

export default ComplaintView;
